(() => {
  "use strict";

  const init = () => {
    const site = document.querySelector("[data-armzone-site]");
    if (!site || site.dataset.homeMenuFixInitialized === "true") return;
    site.dataset.homeMenuFixInitialized = "true";

    const menuButton = site.querySelector("[data-menu-open]");
    const menuDrawer = site.querySelector("[data-menu-drawer]");
    const overlay = site.querySelector("[data-drawer-overlay]");
    const closeButton = site.querySelector("[data-menu-close]");

    if (!menuButton || !menuDrawer) return;

    const lockPage = () => {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    };

    const unlockPage = () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };

    const openMenu = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      menuDrawer.classList.add("open");
      menuDrawer.setAttribute("aria-hidden", "false");
      overlay?.classList.add("active");
      menuButton.setAttribute("aria-expanded", "true");
      lockPage();
    };

    const closeMenu = (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      menuDrawer.classList.remove("open");
      menuDrawer.setAttribute("aria-hidden", "true");
      overlay?.classList.remove("active");
      menuButton.setAttribute("aria-expanded", "false");
      unlockPage();
    };

    menuButton.setAttribute("aria-expanded", "false");
    menuButton.addEventListener("click", openMenu, true);
    closeButton?.addEventListener("click", closeMenu, true);
    overlay?.addEventListener("click", closeMenu, true);

    menuDrawer.querySelectorAll("[data-drawer-link]").forEach((link) => {
      link.addEventListener("click", () => {
        menuDrawer.classList.remove("open");
        menuDrawer.setAttribute("aria-hidden", "true");
        overlay?.classList.remove("active");
        menuButton.setAttribute("aria-expanded", "false");
        unlockPage();
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && menuDrawer.classList.contains("open")) {
        closeMenu();
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
